import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    class: "siteSearch-hit",
    "data-hit": "edu_service"
};
const _hoisted_2 = ["data-accent-color"];
const _hoisted_3 = { class: "cardMod-media" };
const _hoisted_4 = {
    key: 0,
    class: "cardMod-eduStage"
};
const _hoisted_5 = ["href", "aria-label"];
const _hoisted_6 = ["src"];
const _hoisted_7 = { class: "cardMod-notices" };
const _hoisted_8 = {
    key: 0,
    class: "this-notice"
};
const _hoisted_9 = {
    key: 1,
    class: "this-notice is--new"
};
const _hoisted_10 = { class: "cardMod-content" };
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = { class: "cardMod-title" };
const _hoisted_13 = ["href", "innerHTML"];
const _hoisted_14 = ["href", "title"];
import { computed } from 'vue';
import { ThemeIcon } from '../../index';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EduService',
    props: {
        document: {}
    },
    setup(__props) {
        const props = __props;
        const color = computed(() => {
            switch (props.document.post_type) {
                case 'skp_conference':
                    return 'quin';
                case 'skp_course':
                    return 'tert';
                case 'skp_lecture':
                    return 'sen';
                default:
                    return 'primary';
            }
        });
        return (_ctx, _cache) => {
            var _a, _b;
            return (_openBlock(), _createElementBlock("li", _hoisted_1, [
                _createElementVNode("article", {
                    class: "cardMod appearance--generic",
                    "data-accent-color": color.value
                }, [
                    _createElementVNode("div", _hoisted_3, [
                        (_ctx.document.edu_stages_range)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.document.edu_stages_range), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("a", {
                            href: _ctx.document.url,
                            "aria-label": _ctx.document.read_more_label || ''
                        }, [
                            _createElementVNode("img", {
                                src: _ctx.document.thumbnail_url,
                                alt: ""
                            }, null, 8, _hoisted_6)
                        ], 8, _hoisted_5),
                        _createElementVNode("div", _hoisted_7, [
                            (_ctx.document.event)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.document.event.formatted_date_range), 1))
                                : _createCommentVNode("", true),
                            (_ctx.document.is_new)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Ny"))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        (_ctx.document.kind)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "cardMod-kind",
                                innerHTML: ((_a = _ctx.document._formatted) === null || _a === void 0 ? void 0 : _a.kind) || _ctx.document.kind
                            }, null, 8, _hoisted_11))
                            : _createCommentVNode("", true),
                        _createElementVNode("h3", _hoisted_12, [
                            _createElementVNode("a", {
                                href: _ctx.document.url,
                                innerHTML: ((_b = _ctx.document._formatted) === null || _b === void 0 ? void 0 : _b.title) || _ctx.document.title
                            }, null, 8, _hoisted_13)
                        ])
                    ]),
                    _createElementVNode("a", {
                        class: "cardMod-link",
                        href: _ctx.document.url,
                        title: _ctx.document.read_more_label || ''
                    }, [
                        _createVNode(_unref(ThemeIcon), { name: "arrow-right-long" }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.document.read_more_label), 1)
                    ], 8, _hoisted_14)
                ], 8, _hoisted_2)
            ]));
        };
    }
});
